import {Store} from 'redux';
import myCreateStore from '../reduxstore/create-store';
import {container, TYPES} from './inversify-config';
import MeepoState from '../reduxstore/meepo-state';
import AppAction from '../reduxstore/actions/action';
import MeepoServiceClient from '../middleware/meepo-client';
import {FirebaseClient} from '../middleware/firebase';
import UserClient from '../middleware/user-client';


const store = myCreateStore();
container.bind<Store<MeepoState, AppAction>>(TYPES.REDUX_STORE).toConstantValue(store);

if (!container.isBound(TYPES.MEEPO_SERVICE)) {
    container.bind<MeepoServiceClient>(TYPES.MEEPO_SERVICE).to(MeepoServiceClient).inSingletonScope();
}

if (!container.isBound(TYPES.FIREBASE)) {
    container.bind(TYPES.FIREBASE).to(FirebaseClient).inSingletonScope();
}

if (!container.isBound(TYPES.USER_SERVICE)) {
    container.bind<UserClient>(TYPES.USER_SERVICE).to(UserClient).inSingletonScope();
}


// WEBPACK FOOTER //
// ./src/utils/container-bootstrap.ts